import ROUTERS from "./router";
import { ReactComponent as NavHomeOn } from "../../assets/images/nav_home_on.svg";
import { ReactComponent as NavHomeOff } from "../../assets/images/nav_home_off.svg";
import { ReactComponent as NavCameraOn } from "../../assets/images/nav_camera_on.svg";
import { ReactComponent as NavCameraOff } from "../../assets/images/nav_camera_off.svg";
import { ReactComponent as NavGiftOn } from "../../assets/images/nav_gift_on.svg";
import { ReactComponent as NavGiftOff } from "../../assets/images/nav_gift_off.svg";
import { ReactComponent as NavPhotoOn } from "../../assets/images/nav_photo_on.svg";
import { ReactComponent as NavPhotoOff } from "../../assets/images/nav_photo_off.svg";
import { ReactComponent as NavVideoOn } from "../../assets/images/nav_video_on.svg";
import { ReactComponent as NavVideoOff } from "../../assets/images/nav_video_off.svg";

const navLinkBottoms = [
  {
    id: 1,
    name: 'HOME',
    icon: {
      'on' : <NavHomeOn />,
      'off' : <NavHomeOff />,
    },
    className: {
      'on' : 'on',
      'off' : 'off',
    },
    action: '',
    toUrl: ROUTERS.HOME,
  },
  {
    id: 2,
    name: 'CAMERA',
    icon: {
      'on' : <NavCameraOn />,
      'off' : <NavCameraOff />,
    },
    className: {
      'on' : 'on',
      'off' : 'off',
    },
    action: 'login',
    toUrl: ROUTERS.CAMERA,
  },
  {
    id: 3,
    name: 'VIDEO',
    icon: {
      'on' : <NavVideoOn />,
      'off' : <NavVideoOff />
    },
    className: {
      'on' : 'on',
      'off' : 'off',
    },
    action: '',
    toUrl: ROUTERS.VIDEO_MESSAGE_MAKER,
  },
  {
    id: 4,
    name: 'GIFTBOX',
    icon: {
      'on' : <NavGiftOn />,
      'off' : <NavGiftOff />,
    },
    className: {
      'on' : 'on',
      'off' : 'off',
    },
    action: '',
    toUrl: ROUTERS.GIFTBOX_POINT,
  },
  {
    id: 5,
    name: 'ALBUM',
    icon: {
      'on' : <NavPhotoOn />,
      'off' : <NavPhotoOff />,
    },
    className: {
      'on' : 'on',
      'off' : 'off',
    },
    action: '',
    toUrl: ROUTERS.ALBUM,
  },
];

export default navLinkBottoms;